import { CMSLink } from '~/shared/components';
import styles from './meta-list.module.css';
import { clsx } from 'clsx';
import { Link } from '~/lib/data-contract';
import { memo } from 'react';

type Props = {
    metaMenu: Link[];
    className?: string;
    onlyMobile?: boolean;
};

const MetaList = memo(({ metaMenu, className, onlyMobile }: Props) => {
    return (
        <ul className={clsx(styles.root, className, { [styles.onlyMobile]: onlyMobile })}>
            {metaMenu.map(({ text, id, url }) => (
                <li key={`${id}-${text}`} className={styles.item}>
                    <CMSLink
                        href={url}
                        className={clsx(styles.link, 'hover-effect-underline-center')}
                    >
                        {text}
                    </CMSLink>
                </li>
            ))}
        </ul>
    );
});

MetaList.displayName = 'MetaList';
export default MetaList;
